import React, { Component } from 'react'
import { Container, Button, Toolbar, SearchField, Label } from '@sencha/ext-modern'
import { compose } from 'redux'
import { connect } from 'react-redux'

import { doGetDailyTaskHasBeenCompletedList, doDecryptBarCode } from 'tyan/reducers/actions'
import Message from 'tyan/components/Message'
import escapeRegExp from 'escape-string-regexp'
import { WX } from 'tyan/public'

Ext.require([
	'Ext.dataview.listswiper.ListSwiper',
	'Ext.MessageBox'
])

const style = {
	outer: {
		backgroundColor: "#f5f5f5",
		paddingTop: "10px",
		paddingBottom: "10px"
	},
	innerContainer: {
		borderRadius: "10px",
		backgroundColor: "#ffffff",
		margin: "10px",
	},
	titleContainer: {
		borderBottom: "1px solid #f5f5f5",
	},
	titleSmall: {
		margin: 0,
		fontSize: "14px",
	},
	contentContainer: {
		padding: "10px",
		fontSize: "12px",
		color: '#838484'
	},
	checked: {
		color: "#37a1f2",
		paddingTop: "5px"
	},
	unchecked: {
		color: "#959595",
		paddingTop: "5px"
	}
}

class DailyTaskHasBeenCompleted extends Component {
	state = {
		dailyTaskHasBeenCompletedList: null,
		errorMessage: null,
		query: '',
		pageCount: 10,
		page: 1,
		totalCount: 0
	}

	componentDidMount() {
		const { pageCount } = this.state
		this.handleGetDailyTaskList(pageCount)
	}

	onLoadMore() {
		let { page, pageCount } = this.state
		page += 1
		this.handleGetDailyTaskList(pageCount * page)
		this.setState({ page })
	}

	onLoadSelect() {
		const { pageCount } = this.state
		this.handleGetDailyTaskList(pageCount)
	}

	handleGetDailyTaskList = (row) => {
		const { doGetDailyTaskHasBeenCompletedList } = this.props
		doGetDailyTaskHasBeenCompletedList({
			row,
			query: this.state.query,
			onEnd: ({ errorMessage, dailyTaskHasBeenCompletedList, totalCount }) => {
				this.setState({ dailyTaskHasBeenCompletedList, errorMessage, totalCount })
			}
		})
	}

	handleChildTap = (dailyTaskID, status) => {
		location.hash = `/QYWX/DailyTaskStatus/${dailyTaskID}`
	}

	handleChange = (field, value) => {
		this.setState({ query: value })
	}

	handleScanQRCode = (testResult) => {
		const { doDecryptBarCode } = this.props
		this.setState({ testResult: testResult })
		WX.scanQRCode({
			onScaned: ({ code }) => {
				doDecryptBarCode({
					barCode: code,
					onEnd: ({ errorMessage, barCode }) => {
						this.setState({ query: barCode, errorMessage })
					}
				})
			}
		})
	}

	dailyTaskHasBeenCompletedList = dailyTaskHasBeenCompletedList => {
		const { totalCount } = this.state
		let showDailyTaskList = dailyTaskHasBeenCompletedList
		return (<Container layout={{ type: "vbox" }}>
			{showDailyTaskList && showDailyTaskList.map((o, index) => {
				return (
					<Container key={index} layout={{ type: "vbox" }} style={style.innerContainer} >
						<Container layout={{ type: "hbox", pack: "space-between" }} style={style.titleContainer} >
							<Container layout={{ type: "hbox", pack: "start" }}>
								<Container layout="center" padding="10"><i style={{ color: '#fbb805' }} className={"fa fa-envelope"} ></i></Container>
								<Container layout="center" padding="0 10 0 0"><h6 style={style.titleSmall}>{o.number}</h6></Container>
							</Container>
						</Container>
						<Container layout={{ type: 'vbox', pack: 'start' }} style={style.contentContainer}>
							{o && o.fields.map((item, index) => {
								return (<Label cls="label" key={index} html={item.name + ': ' + item.value} padding="0 0 3 0" />)
							})}
						</Container>
						<Container layout={{ type: "hbox", pack: "space-between" }} >
							<Container layout={{ type: "hbox", pack: "start" }} ><div style={style.contentContainer} onClick={() => { this.handleChildTap(o.dailyTaskID, o.status) }}>详情</div></Container>
							<Container layout="center"><div style={style.contentContainer} onClick={() => { this.handleChildTap(o.dailyTaskID, o.status) }}>＞</div></Container>
						</Container>
					</Container>
				)
			})}
			{totalCount > showDailyTaskList.length && <Container layout="center">
				<Button ui="" text="加载更多..." handler={() => this.onLoadMore()} />
			</Container>}
		</Container>
		)
	}

	render() {
		const { dailyTaskHasBeenCompletedList, errorMessage, query } = this.state
		if (errorMessage) {
			return <Message text="数据加载失败" subText={errorMessage} />
		} else if (!dailyTaskHasBeenCompletedList) {
			return <Message text="数据加载中..." />
		}

		return (
			<Container layout={{ type: "vbox" }} style={style.outer} scrollable >
				<Toolbar shadow={false} docked="top" padding="0" margin="0">
					<SearchField ui="faded" placeholder="任务编号" margin="0 20 0 20" value={query} onChange={this.handleChange} width="220px" />
					<Container layout="center">
						<Button ui="" text="搜索" handler={() => this.onLoadSelect()} />
					</Container>
				</Toolbar>
				{this.dailyTaskHasBeenCompletedList(dailyTaskHasBeenCompletedList)}
			</Container>
		)
	}
}

const mapStateToProps = ({ dailyTaskHasBeenCompletedList }) => ({
	...dailyTaskHasBeenCompletedList
})

export default compose(
	connect(mapStateToProps, { doGetDailyTaskHasBeenCompletedList, doDecryptBarCode }),
)(DailyTaskHasBeenCompleted)